// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2nVho","buttons":"PendingPaymentAlert_buttons__28B0D"};